import { useCallback, useMemo, useState } from 'react';
import ShowrunnerMap from './ShowRunnerMap';
import { INIT_MAP_VIEW_STATE, trendingShowsLayer, regularShowsLayer } from '../util/data-factory';

const parse = value => {
  if (typeof value !== 'string') return value;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

function ShowsMapView({ shows, className = 'h-[65vh] md:h-[75vh]' }) {
  const [viewState, setViewState] = useState(() => {
    const first = shows.find(s => Number.isFinite(parseFloat(s.venues?.latitude)));
    return first
      ? {
          latitude: parseFloat(first.venues.latitude),
          longitude: parseFloat(first.venues.longitude),
          zoom: 12,
        }
      : { ...INIT_MAP_VIEW_STATE, zoom: 12 };
  });
  const [popup, setPopup] = useState(null);

  const featureData = useMemo(
    () => ({
      type: 'FeatureCollection',
      features: shows
        .map(show => {
          const lng = parseFloat(show.venues?.longitude);
          const lat = parseFloat(show.venues?.latitude);
          return {
            type: 'Feature',
            geometry: { type: 'Point', coordinates: [lng, lat] },
            properties: { ...show, lat, lng },
          };
        })
        .filter(f => f.geometry.coordinates.every(Number.isFinite)),
    }),
    [shows]
  );

  const onPinClick = useCallback((event, mapRef) => {
    const feature = event.features?.[0];
    if (!feature) return;
    event.originalEvent.stopPropagation();
    if (feature.layer.id !== trendingShowsLayer.id && feature.layer.id !== regularShowsLayer.id) {
      return;
    }
    const props = feature.properties;
    setPopup({
      info: { ...props, venues: parse(props.venues) ?? {} },
      images: parse(props.image_urls) ?? [],
      tags: parse(props.top_tags) ?? [],
    });
    mapRef.current?.flyTo({ center: [props.lng, props.lat], essential: true, duration: 1000 });
  }, []);

  return (
    <div className={`relative w-full overflow-hidden rounded-xl ${className}`}>
      <ShowrunnerMap
        mainMapViewState={viewState}
        featureData={featureData}
        mapPopupInfo={popup?.info}
        mapImageInfo={popup?.images}
        mapTopTagsInfo={popup?.tags}
        onPinClick={onPinClick}
        onMove={e => setViewState(e.viewState)}
        closeShowMapDialog={() => setPopup(null)}
      />
    </div>
  );
}

export default ShowsMapView;
